import { useState } from "react";
import type { HotItem } from "@/mocks/trending";
import { topList, entList, techList, lifeList, rankCategories } from "@/mocks/trending";

const pool: Record<string, HotItem[]> = {
  all: topList,
  ent: entList,
  tech: techList,
  life: lifeList,
};

function TrendIcon({ trend }: { trend: HotItem["trend"] }) {
  if (trend === "up") {
    return (
      <span className="w-4 h-4 flex items-center justify-center text-primary-500">
        <i className="ri-arrow-up-line text-sm"></i>
      </span>
    );
  }
  if (trend === "down") {
    return (
      <span className="w-4 h-4 flex items-center justify-center text-secondary-600">
        <i className="ri-arrow-down-line text-sm"></i>
      </span>
    );
  }
  return (
    <span className="w-4 h-4 flex items-center justify-center text-foreground-300">
      <i className="ri-arrow-right-line text-sm"></i>
    </span>
  );
}

function rankColor(rank: number) {
  if (rank === 1) return "text-primary-600";
  if (rank === 2) return "text-accent-600";
  if (rank === 3) return "text-secondary-600";
  return "text-foreground-300";
}

export default function HotBoard() {
  const [cat, setCat] = useState("all");
  const rows = pool[cat];

  return (
    <section id="hotboard" className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
      {/* 分区标题 */}
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 text-2xl md:text-3xl font-black text-foreground-950">
            <span className="w-9 h-9 flex items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-fire-fill"></i>
            </span>
            91cg 实时热榜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            关注度高的内容自动顺位排前，群众正在看的、正在讨论的都在这里。
          </p>
        </div>
        <a href="#top" className="shrink-0 inline-flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 cursor-pointer whitespace-nowrap">
          查看完整榜单
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </a>
      </div>

      {/* 分段控制 tab */}
      <div className="mt-6 inline-flex items-center rounded-full border border-background-200 bg-background-100 p-1">
        {rankCategories.map((c) => (
          <button
            key={c.key}
            onClick={() => setCat(c.key)}
            className={`whitespace-nowrap cursor-pointer px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors ${
              cat === c.key
                ? "bg-primary-500 text-background-50"
                : "text-foreground-600 hover:text-primary-600"
            }`}
          >
            {c.label}
          </button>
        ))}
      </div>

      {/* 榜单列表 */}
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1">
        {rows.map((item) => (
          <a
            key={item.id}
            href="#top"
            className="group flex items-center gap-3 rounded-xl px-3 py-3 cursor-pointer hover:bg-background-100/70 transition-colors"
          >
            <span className={`font-display text-2xl w-8 text-center shrink-0 ${rankColor(item.rank)}`}>
              {item.rank}
            </span>
            <span className="w-5 h-5 shrink-0 flex items-center justify-center rounded-md text-[11px] font-bold bg-accent-500 text-background-50">
              {item.tag}
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-[15px] font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                {item.title}
              </p>
              <p className="mt-1 flex items-center gap-2 text-xs text-foreground-400">
                <span>{item.heat} 热度</span>
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-chat-3-line"></i>
                </span>
                <span>{item.comment.toLocaleString()}</span>
              </p>
            </div>
            <div className="flex flex-col items-end gap-1 shrink-0">
              <TrendIcon trend={item.trend} />
              <span className="text-[11px] text-foreground-400 whitespace-nowrap">{item.heatNum}万</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}